export const containsClasses = (
  classNames: string | undefined,
  searchedClassNames: string | string[],
) => {
  if (!classNames) return false;

  const classArray = classNames.split(' ');

  if (typeof searchedClassNames === 'string') {
    searchedClassNames = searchedClassNames.split(' ');
  }

  return searchedClassNames.some((className) => classArray.includes(className));
};
